import { render } from "./TownInfoSection.vue?vue&type=template&id=142796ae"
import script from "./TownInfoSection.vue?vue&type=script&lang=js"
export * from "./TownInfoSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__